import { ApiError } from '../../shared/api/errors';

const messageOf = (error: unknown): string =>
  error instanceof Error ? error.message : typeof error === 'string' ? error : 'Unknown error';

// Request ids and stacks are for whoever builds this; a user sees the sentence, not our insides.
export const errorDetails = (error: unknown): string => {
  const lines = [messageOf(error)];
  if (import.meta.env.DEV) {
    if (error instanceof ApiError) {
      lines.push(
        `${error.status} · ${error.code}${error.requestId ? ` · ${error.requestId}` : ''}`,
      );
    }
    if (error instanceof Error && error.stack) lines.push('', error.stack);
  }
  return lines.join('\n');
};

export const copyText = (error: unknown): string =>
  [`${window.location.href}`, new Date().toISOString(), errorDetails(error)].join('\n');
